// Tempatkan di: src/components/PdfSuratJalanManual/PdfSuratJalanManual.jsx
import React from "react";
import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import moment from "moment";
import { bulan } from "../../util/constant";
import LogoTim from "../../Assets/logo-tim-sj.jpeg";
import {
  formatDot,
  switchDotsAndCommas,
  numberWithCommas,
} from "../../util/utilFunction";

// angka murni diformat titik ribuan seperti SJ biasa, selain itu tampil apa adanya
const showQty = (q) => {
  const s = String(q ?? "").trim();
  return /^\d+$/.test(s)
    ? formatDot(switchDotsAndCommas(numberWithCommas(Number(s))))
    : s;
};

const line = {
  borderTop: "1px dotted black",
  borderBottom: "1px dotted black",
};

/**
 * props: noSj, date (YYYY-MM-DD), noPol, yth,
 *        attnNama (opsional, nama orang), attn (alamat), telp,
 *        items: [{ quantity, satuan, namaBarang, keterangan }]
 */
const PdfSuratJalanManual = ({
  noSj,
  date,
  noPol,
  yth,
  attnNama,
  attn,
  telp,
  items,
}) => {
  const m = moment(date, "YYYY-MM-DD");
  const findBulan = bulan.find((i) => Number(i.value) === m.month() + 1);

  return (
    <Document>
      <Page size="A4" style={{ padding: "8px 0px 0px 0" }}>
        {/* tanpa maxHeight: kalau item banyak, tanda tangan ikut turun (tidak tertimpa) */}
        <View style={{ minHeight: "37%" }}>
          <View
            style={{ flexDirection: "row", width: "100%", fontSize: "10px" }}
          >
            <Text style={{ width: "60%" }}>Form-WH-A1-R2</Text>
            <Text style={{ width: "40%" }}>
              Cimanggis, {m.format("DD")}{" "}
              {findBulan ? findBulan.name.toUpperCase() : ""} {m.format("YYYY")}
            </Text>
          </View>

          <View style={{ flexDirection: "row", width: "100%" }}>
            <View style={{ flexDirection: "row", width: "60%" }}>
              <Image
                style={{ width: "36px", height: "42px", marginRight: "2px" }}
                src={LogoTim}
              />
              <View>
                <Text
                  style={{
                    fontSize: "13px",
                    textDecoration: "underline",
                    fontWeight: "bold",
                    marginBottom: "4px",
                    marginTop: "4px",
                  }}
                >
                  PT. TENAR INTI MANDIRI
                </Text>
                <Text
                  style={{
                    fontSize: "10px",
                    fontStyle: "italic",
                    marginBottom: "2px",
                  }}
                >
                  JL. Kapitan No. 88 RT. 02/05 Curug-Cimanggis Depok
                </Text>
                <Text style={{ fontSize: "10px", fontStyle: "italic" }}>
                  Phone : (021)8743449, 8746560 (Fax)
                </Text>
              </View>
            </View>
            <View style={{ width: "35%", fontSize: "10px" }}>
              <Text style={{ marginBottom: "2px", marginTop: "2px" }}>
                Yth.: {yth}
              </Text>
              {/* nama orang di atas, alamat di bawahnya.
                  Kalau nama kosong, baris Attn tidak dirender sehingga alamat naik. */}
              {attnNama ? (
                <Text style={{ marginBottom: "2px" }}>Attn: {attnNama}</Text>
              ) : null}
              {attn ? (
                <Text style={{ marginBottom: "2px" }}>{attn}</Text>
              ) : null}
              {telp ? <Text>Telp: {telp}</Text> : null}
            </View>
          </View>

          <View
            style={{
              flexDirection: "row",
              width: "100%",
              fontSize: "10px",
              marginBottom: "2px",
            }}
          >
            <Text>SURAT JALAN NO.:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{noSj}</Text>
          </View>

          <View style={{ flexDirection: "row", width: "100%" }}>
            <View style={{ width: "60%", fontSize: "10px" }}>
              <Text>
                Kami kirim barang-barang di bawah ini dengan kendaraan:
              </Text>
            </View>
            <View
              style={{
                width: "37%",
                flexDirection: "row",
                fontSize: "10px",
                justifyContent: "space-between",
              }}
            >
              <Text>BOX</Text>
              <Text>NO.POL.&nbsp;&nbsp;{noPol}</Text>
            </View>
          </View>

          <View
            style={{
              flexDirection: "row",
              width: "100%",
              fontSize: "10px",
              marginTop: "6px",
            }}
          >
            <Text style={{ width: "7%", textAlign: "center", ...line }}>
              No.
            </Text>
            <Text style={{ width: "13%", ...line }}>QUANTITY</Text>
            <Text style={{ width: "50%", textAlign: "center", ...line }}>
              NAMA BARANG
            </Text>
            <Text style={{ width: "30%", textAlign: "center", ...line }}>
              KETERANGAN
            </Text>
          </View>

          {(items || []).map((obj, index) => (
            <View
              key={index}
              wrap={false}
              style={{
                flexDirection: "row",
                width: "100%",
                marginBottom: "3px",
              }}
            >
              <Text
                style={{ width: "7%", textAlign: "center", fontSize: "12px" }}
              >
                {index + 1}
              </Text>
              <View
                style={{
                  width: "13%",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  fontSize: "12px",
                }}
              >
                <Text>{showQty(obj.quantity)}</Text>
                <Text style={{ paddingRight: "6px" }}>{obj.satuan}</Text>
              </View>
              <View style={{ width: "50%" }}>
                {/* satu baris input = satu <Text>; tidak ada HTML, jadi aman dari injeksi */}
                {String(obj.namaBarang || "")
                  .split("\n")
                  .map((line, k) => (
                    <Text
                      key={k}
                      style={{
                        padding: k === 0 ? "0 6px 0 12px" : "1px 6px 0 12px",
                        fontSize: "11px",
                      }}
                    >
                      {line === "" ? " " : line}
                    </Text>
                  ))}
              </View>
              <View style={{ width: "30%", fontSize: "11px" }}>
                <Text>{obj.keterangan}</Text>
              </View>
            </View>
          ))}
        </View>

        <View
          wrap={false}
          style={{
            flexDirection: "row",
            width: "100%",
            fontSize: "10px",
            borderTop: "1px dotted black",
            paddingTop: "6px",
          }}
        >
          {[
            ["Diterima", false],
            ["Supir", true],
            ["Hormat Kami", false],
          ].map(([label, italic]) => (
            <View key={label} style={{ width: "32%", alignItems: "center" }}>
              <Text
                style={{
                  marginBottom: "36px",
                  ...(italic ? { fontStyle: "italic" } : {}),
                }}
              >
                {label}
              </Text>
              <Text>
                (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
              </Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default PdfSuratJalanManual;
